import { useSimilarStores } from '@/hooks/storePageHooks'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Link } from '@tanstack/react-router'
import FollowButton from '@/components/FollowButton' // adjust path if needed
import { ImpersonateActionButton } from './ImpersonateActionButton'
import { StoreLogo } from '@/components/store/StoreLogo';
import { StoreCover } from '@/components/store/StoreCover';

const SimilarStores = ({ cityId, storeTypeId, excludeStoreId }) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useSimilarStores({
      city_id: cityId,
      store_type_id: storeTypeId,
      exclude_store_id: excludeStoreId,
    })

  const stores = data?.pages.flatMap((page) => page.data) || []

  if (isLoading) {
    return (
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">متاجر مشابهة</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="h-64 w-full rounded-lg" />
          ))}
        </div>
      </div>
    )
  }

  if (!stores.length) return null

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">متاجر مشابهة</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {stores.map((store) => (
          <Card
            key={store.id}
            className="hover:shadow-md transition-shadow overflow-hidden"
          >
{store.cover_urls && (
  <div className="h-20 w-full overflow-hidden">
    <StoreCover urls={store.cover_urls} size="thumbnail" className="w-full h-full" />
  </div>
)}
            <CardContent
              className={`p-4 flex flex-col items-center text-center ${!store.cover_photo ? 'pt-6' : ''}`}
            >
<div className="h-16 w-16 -mt-8 mb-2 rounded-full ring-2 ring-background overflow-hidden bg-muted">
  <StoreLogo store={store} size="thumbnail" className="w-full h-full object-cover" />
</div>
              <Link
                to={`/store/${store.slug}`}
                className="font-semibold hover:underline"
              >
                {store.name}
              </Link>
              {(store.city?.name || store.neighborhood?.name) && (
                <p className="text-xs text-muted-foreground mt-1">
                  {[store.city?.name, store.neighborhood?.name]
                    .filter(Boolean)
                    .join(' • ')}
                </p>
              )}
              <div className="flex justify-around w-full mt-3 text-sm border-t pt-2">
                <div>
                  <span className="font-bold">{store.products_count || 0}</span>
                  <span className="text-muted-foreground mr-1">منتجات</span>
                </div>
                <div>
                  <span className="font-bold">
                    {store.followers_count || 0}
                  </span>
                  <span className="text-muted-foreground mr-1">متابعون</span>
                </div>
              </div>
{store.is_owned ? (
  <ImpersonateActionButton
    store={store}
    to="/dashboard/"
    variant="outline"
    className="w-full mt-3"
  >
    إدارة
  </ImpersonateActionButton>
) : (
  <FollowButton
    storeSlug={store.slug}
    initialFollowed={store.is_followed}
    className="w-full mt-3"
  />
)}
            </CardContent>
          </Card>
        ))}
      </div>
      {hasNextPage && (
        <div className="flex justify-center">
          <Button
            variant="outline"
            onClick={() => fetchNextPage()}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? 'جاري التحميل...' : 'تحميل المزيد'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default SimilarStores
